module.exports = __webpack_public_path__ + "static/media/APA_Logo_Stacked_1cRev_lr.5cf852e5.png";